import React, { useEffect, useRef } from 'react';
//import { observer } from 'mobx-react';

export default function FingerPrinting({ children }) {
  const canvasRef = useRef(null);

  const fingerPrint = (canvas, ctx) => {
    //const canvas = document.getElementById('myCanvas');
    //const ctx = canvas.getContext('2d');

    ctx.fillStyle = 'rgb(255,0,255)';
    ctx.beginPath();
    ctx.rect(20, 20, 150, 100);
    ctx.fill();
    ctx.stroke();
    ctx.closePath();
    ctx.beginPath();
    ctx.fillStyle = 'rgb(0,255,255)';
    ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
    ctx.fill();
    ctx.stroke();
    ctx.closePath();

    const txt = 'Insignary2021#$%^@£éú';
    ctx.textBaseline = 'top';
    ctx.font = '17px Arial';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = 'rgb(255,5,5)';
    ctx.rotate(0.03);
    ctx.fillText(txt, 4, 17);
    ctx.fillStyle = 'rgb(155,255,5)';
    ctx.shadowBlur = 8;
    ctx.shadowColor = 'red';
    ctx.fillRect(20, 12, 100, 5);

    // hashing function
    let i = 0;
    let char;
    const src = canvas.toDataURL();
    let hash = 0;

    for (i = 0; i < src.length; i++) {
      char = src.charCodeAt(i);
      // eslint-disable-next-line no-bitwise
      hash = ((hash << 5) - hash) + char;
      hash = hash && hash;
    }

    return hash;
  };
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const currentHash = fingerPrint(canvas, ctx);
    const mixedData = `${currentHash}${Date.now()}`;
    localStorage.setItem('hash', mixedData);
  }, []);

  //const currentHash = fingerPrint();

  return (
    <div>
      {children}
      <canvas ref={canvasRef} width="200" height="40" style={{ border: '1px solid #000000', display: 'none' }} />
    </div>
  );
}
